import { useState } from 'react';
import { Box, Button, Input, Typography } from '@mui/joy';
import DateQuickPicker from './DateQuickPicker';

// Один день всегда отправляет одинаковые границы, период — включительно.
export default function DatePeriodFilter({ from, to, onChange, initialPeriod = 'month' }) {
    const [single, setSingle] = useState(from === to);
    const [active, setActive] = useState(initialPeriod);
    const changeFrom = value => {
        setActive('');
        onChange(value, single || (value && to && value > to) ? value : to);
    };
    return <Box sx={{ mb: 2 }}>
        <DateQuickPicker activeKey={active} onChange={(start, end, key) => {
            setSingle(start === end); setActive(key); onChange(start, end);
        }} />
        <Box sx={{ display: 'flex', gap: 1, mt: 1, mb: 1 }}>
            {[[true, 'Один день'], [false, 'Период']].map(([value, label]) => <Button
                key={label} size="sm" aria-pressed={single === value}
                onClick={() => { setSingle(value); setActive(''); if (value) onChange(from || to, from || to); }}
                sx={{ flex: 1, bgcolor: single === value ? 'rgba(162,38,226,.24)' : 'var(--joy-palette-background-level2)',
                    color: single === value ? 'var(--joy-palette-primary-200)' : 'var(--joy-palette-text-secondary)',
                    border: '1px solid', borderColor: single === value ? 'var(--joy-palette-primary-400)' : 'var(--joy-palette-divider)',
                    '&:hover': { bgcolor: 'rgba(162,38,226,.18)' } }}>{label}</Button>)}
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: single ? '1fr' : 'repeat(2,minmax(0,1fr))', gap: 1 }}>
            <Box sx={{ minWidth: 0 }}><Typography level="body-xs" sx={{ mb: .5 }}>{single ? 'Дата' : 'С даты'}</Typography>
                <Input type="date" size="sm" value={from} onChange={e => changeFrom(e.target.value)}
                    slotProps={{ input: { 'aria-label': single ? 'Дата' : 'С даты' } }} sx={{ minWidth: 0 }} /></Box>
            {!single && <Box sx={{ minWidth: 0 }}><Typography level="body-xs" sx={{ mb: .5 }}>По дату</Typography>
                <Input type="date" size="sm" value={to} onChange={e => {
                    setActive(''); const value = e.target.value;
                    onChange(value && from && value < from ? value : from, value);
                }} slotProps={{ input: { 'aria-label': 'По дату' } }} sx={{ minWidth: 0 }} /></Box>}
        </Box>
    </Box>;
}
